// shared-library/api/services/funnelApi.js
/**
 * 商机漏斗相关API服务
 */
export default function(apiClient) {
  return {
    /**
     * 获取所有商机漏斗数据
     */
    getAllFunnels() {
      return apiClient.get('/cm/funnel/list')
    },

    /**
     * 推进商机
     * @param {number} funnelId - 商机ID
     * @param {object} pushData - 推进数据
     */
    pushFunnel(funnelId, pushData) {
      return apiClient.post(`/cm/funnel/${funnelId}/push`, pushData)
    },

    /**
     * 修改商机
     * @param {number} funnelId - 商机ID
     * @param {object} updateData - 更新数据
     */
    updateFunnel(funnelId, updateData) {
      return apiClient.post(`/cm/funnel/${funnelId}/update`, updateData)
    }
  }
}